// extracted by mini-css-extract-plugin
module.exports = {"orange":"#e38826","darkCyan":"#006970","veryDarkCyan":"#004241","btn":"css-653ca22","btn--link":"css-c830c3b"};